import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserWatchlist } from "layouts/applications/data-tables/data/getData";

const initialState = {
  loading: true,
  watchlist: [],
};

export const loadUserWatchlist = createAsyncThunk("user/watchlist", async () => {
  const userWatchlist = await getUserWatchlist();
  return userWatchlist;
});

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: () => {},
    addToWatchlist: (state, action) => {
      if (state.watchlist.filter((item) => item.symbol === action.payload.symbol).length === 0)
        state.watchlist.push(action.payload);
    },
    removeFromWatchlist: (state, action) => {
      state.watchlist = state.watchlist.filter((item) => item.symbol !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadUserWatchlist.fulfilled, (state, action) => {
      if (action.payload === null) return;
      state.loading = false;
      state.watchlist = action.payload;
    });
  },
});

export const { logout, addToWatchlist, removeFromWatchlist } = userSlice.actions;

export default userSlice.reducer;
